import React from "react";

/**
 * Reusable card for account lifecycle actions (Deactivate, Delete, Mark for Deletion, etc.)
 *
 * @param {Object} props
 * @param {string} props.title - Action title (e.g. "Deactivate Account")
 * @param {string} props.description - Explanatory text describing the action
 * @param {string} props.buttonText - Text inside the action button
 * @param {Function} props.onAction - Handler triggered when button is clicked
 * @param {boolean} [props.disabled=false] - Whether the action button is disabled
 * @param {string} [props.variant="secondary"] - Button variant: "secondary" | "danger" | "primary"
 */
const AccountActionCard = ({
  title,
  description,
  buttonText,
  onAction,
  disabled = false,
}) => {
  return (
    <div
      className="mfa-method-card"
      style={{
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        padding: "12px 16px",
      }}
    >
      <div style={{ flex: 1, marginRight: "16px" }}>
        <p
          style={{
            fontWeight: "500",
            margin: "0 0 4px 0",
            color: "#1e293b",
          }}
        >
          {title}
        </p>
        <p
          style={{
            fontSize: "16px",
            color: "#64748b",
            margin: 0,
            lineHeight: "1.4",
          }}
        >
          {description}
        </p>
      </div>

      <button
        type="button"
        className="cta-button secondary short"
        onClick={onAction}
        disabled={disabled}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default AccountActionCard;
